import styled from 'styled-components';

export const WrapperAccordion = styled.div`
  font-family: 'Montserrat', sans-serif;

  .accordion-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    margin-left: 0.5rem;
    & + * {
      margin-top: 10px;
    }

    &:last-child {
      margin-bottom: 1rem;
    }
  }

  .accordion-item {
    overflow: hidden;
    transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
    height: auto;
    max-height: 9999px;
  }

  .accordion-item.collapsed {
    max-height: 0;
    transition: max-height 0.35s cubic-bezier(0, 1, 0, 1);
  }

  .accordion-title {
    font-family: Source Sans Pro;
    font-weight: bold;
    font-size: 1rem;
    cursor: pointer;
    color: #fcff7c;
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: '';
      color: #fcff7c;
      border-left: 0.125rem solid #fcff7c;
      border-bottom: 0.125rem solid #fcff7c;
      width: 5px;
      height: 5px;
      margin-left: 0.7rem;
      transition: transform 0.2s linear;
      transform: rotate(-45deg);
    }

    &.open {
      &::after {
        content: '';
        border-left: 0.125rem solid #fcff7c;
        border-bottom: 0.125rem solid #fcff7c;
        transform: rotate(135deg);
      }
    }
  }

  .accordion-content {
    text-align: center;
    margin-right: 2rem;

    .nav-links_mobile {
      a {
        text-decoration: none;
      }
      ul {
        li {
          color: #fff;
          list-style: none;
          margin-top: 1rem;
        }
      }
    }
  }
`;
